import styled from 'styled-components';

export const StyledSelectedVehicleInfo = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 16px 22px;
    background: ${({ theme }) => theme.tokens.BaseColorWhite};

    .selected-vehicle-info-right {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-end;
        padding-right: 8px;
    }
    .selected-vehicle-name {
        text-transform: capitalize;
    }
    .vehicle-field {
        display: flex;
        align-items: center;
        margin-bottom: 4px;

        .field-label {
            color: ${({ theme }) => theme.tokens.BaseColorGray600};
        }

        .field-value {
            padding-left: 4px;
            color: ${({ theme }) => theme.tokens.BaseColorGray900};
        }
    }
`;
